import { SxProps, TextField, TextFieldProps, Theme } from '@mui/material';
import { forwardRef } from 'react';
import { styles } from '~/components/TextField/styles.ts';
import { isEmpty } from 'lodash';

export const TextInput = forwardRef<HTMLDivElement, TextFieldProps>((props, ref) => {
  return (
    <TextField
      {...props}
      ref={ref}
      inputRef={props.inputRef}
      slotProps={{
        ...props.slotProps,
        inputLabel: { ...props.slotProps?.inputLabel, shrink: true },
      }}
      placeholder={
        props.disabled && isEmpty(props.value) ? 'Поле заблоковано для вводу' : props.placeholder
      }
      sx={
        {
          ...(props.sx as SxProps<Theme>),
          ...styles.disabled,
          ...styles.size,
        } as SxProps
      }
    />
  );
});
